import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    ElementRef, EventEmitter, Inject, LOCALE_ID,
    OnDestroy,
    TemplateRef,
    ViewChild,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatLegacyTableDataSource } from '@angular/material/legacy-table';
import { MatSort, Sort } from '@angular/material/sort';

import {
    BehaviorSubject,
    combineLatest,
    defer,
    finalize,
    Observable,
    of,
    ReplaySubject,
    Subject,
    Subscription,
} from 'rxjs';
import {
    debounceTime,
    distinctUntilChanged,
    filter,
    map,
    shareReplay,
    startWith,
    switchMap,
    take, takeUntil,
    tap,
} from 'rxjs/operators';
import { CommissionEntity } from '../../../dave-data-module/entities/commission.entity';
import { CommissionTypeEntity } from '../../../dave-data-module/entities/commissionType.entity';
import { CustomerEntity } from '../../../dave-data-module/entities/customer.entity';
import { DamageFlowEntity } from '../../../dave-data-module/entities/damageflow.entity';
import { PartnerSpecificationType } from '../../../dave-data-module/entities/partner.entity';
import { StatusFromBackofficeEntity } from '../../../dave-data-module/entities/statusFromBackoffice.entity';
import { UserEntity } from '../../../dave-data-module/entities/user.entity';
import { CommissionResolver } from '../../../dave-data-module/guards/commission.resolver';
import { DamageFlowResolver } from '../../../dave-data-module/guards/damageflow.resolver';
import { StatusFromBackofficeResolver } from '../../../dave-data-module/guards/statusFromBackoffice.resolver';
import { User2CommissionShiftResolver } from '../../../dave-data-module/guards/user-to-commission-shift.resolver';
import { getFetched$ } from '../../../dave-data-module/helper/helper';
import { State } from '../../../dave-data-module/State';
import { ChangeSettings } from '../../../dave-data-module/State/actions/settings.actions';
import {
    getCommissionsFetched,getCommissionsUndeleted
} from '../../../dave-data-module/State/selectors/commission.selector';
import { getCommissionTypes } from '../../../dave-data-module/State/selectors/commissionType.selectors';
import { getCustomers } from '../../../dave-data-module/State/selectors/customers.selectors';
import { getDamageFlows,getDamageFlowsFetched } from '../../../dave-data-module/State/selectors/damageflow.selector';
import { getPartner,getPartnerFetched } from '../../../dave-data-module/State/selectors/partners.selectors';
import {
    getStatusFromBackoffice,
    getStatusFromBackofficeById,
    getStatusFromBackofficeDictionary,
    getStatusFromBackofficeFetched,
} from '../../../dave-data-module/State/selectors/statusFromBackoffice.selectors';
import {
    getUserToCommissionShiftFetched,
    getUserToCommissionShiftsActive
} from '../../../dave-data-module/State/selectors/users-to-commission-shift.selectors';
import {
    getSetting,
    getSettingFetched,
    getUser, getUserDictionary,
    getUsers,
} from '../../../dave-data-module/State/selectors/users.selectors';
import {
    compareArrays,
    getAddressString, getCommissionColorValue,
    isNotNullOrUndefined,
    SearchQueriesDebounceTime,
    sortMatTableData,
    TableColumnConfig,
    uniqArray,
} from '../../../helper/helper';
import { CommentIcon, CommissionMeta } from '../../../helper/page-metadata';
import { CustomLabelService } from '../../../services/custom-label/custom-label.service';
import { Store } from '@ngrx/store';
import { MatTable } from '@angular/material/table';
import { getEntityRole, getEntityRoleFetched } from '../../../dave-data-module/State/selectors/entity-role.selector';
import {
    EntityRoleEntity,
    EntityRoleSlugEnum,
    EntityTypesEnum,
} from '../../../dave-data-module/entities/entity-role.entity';
import {
    getCommentByEntityTypeEntityId,
    getCommentFetched,
} from '../../../dave-data-module/State/selectors/comment.selector';
import { CommentEntity, CommentEntityTypeEnum } from '../../../dave-data-module/entities/comment.entity';
import {
    getLedgerImports,
    getLedgerImportsFetched,
} from '../../../dave-data-module/State/selectors/ledger-import.selector';
import { LedgerImportResolver } from '../../../dave-data-module/guards/ledger-import.resolver';
import {
    CommentListDialogComponent,
    CommentListDialogComponentDialogData,
} from '../../../dave-comments/components/comment-list-dialog/comment-list-dialog.component';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import {
    LedgerImportDocumentTypes,
    LedgerImportStatusEnum,
} from '../../../dave-data-module/entities/ledger-import.entity';
import { DatePipe, formatCurrency, getCurrencySymbol } from '@angular/common';
import {
    SelectUserCommissionDialogComponent,
    SelectUserCommissionDialogComponentDialogData,
} from '../../../dave-select-user/components/select-user-dialogs/select-user-commission-dialog/select-user-commission-dialog.component';
import { UserToCommissionEntity } from '../../../dave-data-module/entities/user-to-commission.entity';
import { Dictionary } from '@ngrx/entity';
import {
    getUserToCommissionCommissionIdsMap, getUserToCommissionDictionary,
    getUserToCommissionFetched, getUserToCommissions,
} from '../../../dave-data-module/State/selectors/user-to-commission.selector';
import { UserToCommissionResolver } from '../../../dave-data-module/guards/user-to-commission.resolver';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { isNullOrUndef } from 'chart.js/helpers';
import { CustomerDataService } from '../../../dave-data-module/services/customer-data.service';
import { CommentResolver } from '../../../dave-data-module/guards/comment.resolver';


export type CommissionListColumn =
    | 'InterneNr'
    | 'AuftragsNr'
    | 'SchadenNr'
    | 'Datum'
    | 'Ort'
    | 'VersicherungsNr'
    | 'Projektleiter'
    | 'Vorarbeiter'
    | 'StatusBackoffice'
    | 'Auftraggeber'
    | 'LastDeadline'
    | 'AbgabeterminAG'
    | 'StartDate'
    | 'EndDate'
    | 'Address'
    | 'Sachbearbeiter'
    | 'Description'
    | 'Auftragstyp'
    | 'Author'
    | 'CreatedAt'
    | 'lastComment'
    | 'offerSum'
    | 'freeTextField1'
    | 'CostCenter'
    | 'OfferSubmissionDate'
    | 'NegotiationAt'
    | 'CompleteBusinessVolume'
    ;
function getUserNamesByRoleId(u2csByCommission: UserToCommissionEntity[], roleId: number, users: Dictionary<UserEntity>) {
    return uniqArray(u2csByCommission.filter((u2c) => u2c.RoleId === roleId).map((u2c) => u2c.UserId))
        .map((uId) => users[uId])
        .filter((user) => user && !user.Deleted)
        .map((user) => user.DisplayName)
        .join(' | ');
}


type TableData = {
    AuftragsNr: string;
    InterneNr: string;
    Description: string;
    Ort: string;
    Datum: Date;
    DatumAsMillis: number;
    Auftrag: CommissionEntity;
    backgroundColor: string | null;
    tooltip: string;
    StatusBackoffice: string;
    StartDate: Date;
    StartDateAsMillis: number;
    EndDate: Date;
    EndDateAsMillis: number;
    Auftraggeber: string;
    Auftragstyp: string;
    Address: string;
    AbgabeterminAG: string;
    Author: string;
    // Projektleiter: string;
    // Vorarbeiter: string;
    // Monteur: string;
    //  Admin: string;
    SchadenNr: string;
    VersicherungsNr: string;
    offerSum$: Observable<string>;
    freeTextField1: string;
    lastComment$: Observable<string>;
    roleCols: { [key: string]: string };
    colorBarValue: string;
    CostCenter: string;
    OfferSubmissionDate: string;
    OfferSubmissionDateAsMillis: number;
    NegotiationAt: string;
    NegotiationAtAsMillis: number;
    CompleteBusinessVolume: string;
}
const roleKeyPrefix = 'roleId_';


@Component({
    selector: 'app-commission-dashboard',
    templateUrl: './commission-dashboard.component.html',
    styleUrls: ['./commission-dashboard.component.scss'],
    providers: [DatePipe],
})
export class CommissionDashboardComponent implements OnDestroy, AfterViewInit {
    @ViewChild('searchInput') searchInput: ElementRef;
    @ViewChild(MatSort) private matSortDOM?: MatSort;
    @ViewChild(MatTable) table!: MatTable<any>;
    @ViewChild('lastCommentCell') protected lastCommentTemplate: TemplateRef<any>;
    @ViewChild('offerSumCell') protected offerSumTemplate: TemplateRef<any>;
    @ViewChild('roleCell') protected roleTemplate: TemplateRef<any>;
    @ViewChild('hasChildCell') protected hasChildTemplate: TemplateRef<any>;

    private destroy$ = new Subject<void>();

    private afterViewInit$ = new ReplaySubject<void>(1);
    commissionEntityRoles$ = this.store.select(getEntityRoleFetched).pipe(
        filter((v) => v),
        switchMap(() => this.store.select(getEntityRole)),
        map((roles) => roles.filter((r) => r.Entity === EntityTypesEnum.Commission)),
        shareReplay({ refCount: true, bufferSize: 1 }),
    );
    protected customCellTemplates$ = combineLatest([this.commissionEntityRoles$, this.afterViewInit$]).pipe(
        map(([roles, init]) => {
            const roleCols: { [key: string]: TemplateRef<any> } = {};
            roles.forEach((r) => {
                roleCols[roleKeyPrefix + r.Id] = this.roleTemplate;
            });
            return<{[key: string]: TemplateRef<any>}> {
                lastComment: this.lastCommentTemplate,
                offerSum: this.offerSumTemplate,
                AuftragsNr: this.hasChildTemplate,
                ...roleCols,
            };
        })
    )

    private subscriptions: Subscription[] = [];
    private getSettingsCommissionFilter$ = this.store.select(getSetting).pipe(
        map((s) => s?.FilterCommissions),
        distinctUntilChanged((a, b) => JSON.stringify(a) === JSON.stringify(b)),
    );
    protected searchVisible = false;
    protected searchForm = new FormControl<string>('');

    private commissionData$ = getFetched$(this.store, getCommissionsFetched, getCommissionsUndeleted).pipe(
        shareReplay({ refCount: true, bufferSize: 1 }),
    );

    private customersDict$ = this.commissionData$.pipe(
        map((commissions) => commissions.map((c) => c.CustomerId).filter(isNotNullOrUndefined)),
        switchMap((customerIds) => this.customerDataService.GetCustomersDict$(customerIds)),
        shareReplay({ refCount: true, bufferSize: 1 }),
    );

    public getDataSourceByBackofficeStatus(statusId: number): { dataSource$: Observable<MatLegacyTableDataSource<TableData>>; loading$: Observable<boolean> } {
        const loading$ = new BehaviorSubject<boolean>(true);

        const dataSource$ = defer(() => {
            loading$.next(true);

            return combineLatest([
                getFetched$(this.store, getCommissionsFetched, getCommissionsUndeleted),
                this.afterViewInit$,
                this.store.select(getDamageFlowsFetched).pipe(
                    filter((v) => v),
                    switchMap(() => this.store.select(getDamageFlows)),
                ),
                getFetched$(this.store, getStatusFromBackofficeFetched, getStatusFromBackofficeById({ id: statusId })),
                this.getSettingsCommissionFilter$.pipe(switchMap(filter => filter ? combineLatest([
                    getFetched$(this.store, getUserToCommissionFetched, getUserToCommissions),
                    this.commissionEntityRoles$,
                    this.store.select(getUser),
                ]).pipe(map(([u2cs, entityRoles, user]) => {
                    const unwantedRoleNames = [EntityRoleSlugEnum.Admin, EntityRoleSlugEnum.Nutzer, EntityRoleSlugEnum.Leser];
                    const ignoredRoles = entityRoles.filter(r => unwantedRoleNames.some(s => s === r.Name)).map(r => r.Id);
                    return uniqArray(u2cs.filter(u2c => u2c.UserId === user.Id && (u2c.Assignee || (u2c.RoleId && !ignoredRoles.includes(u2c.RoleId)))).map(u2c => u2c.CommissionId))
                })) : of(null))),
                this.customersDict$,
                this.store.select(getCommissionTypes),
                this.store.select(getUsers), getFetched$(this.store, getCommentFetched, getCommentFetched, this.commentResolver), combineLatest([
                    getFetched$(this.store, getUserToCommissionFetched, getUserToCommissionCommissionIdsMap).pipe(switchMap((u2cCIdsMap) => this.store.select(getUserToCommissionDictionary).pipe(map((u2cDict) => ({ u2cDict, u2cCIdsMap }))))),
                    this.commissionEntityRoles$,
                ]),
                this.store.select(getUserDictionary),
            ]).pipe(
                map(([commissions, viewInit, damageFlows, StatusBackoffice, u2csFilterCommissionIds, customers, commissionTyp, users, commentsfetched, [{ u2cDict, u2cCIdsMap }, roles], userDict]) => {
                    if (u2csFilterCommissionIds) {
                        commissions = commissions.filter((c) => c.ImAssigned || u2csFilterCommissionIds.includes(c.Id));
                    }
                    commissions = commissions
                        ?.filter((c) => c.StatusBackofficeId === statusId)
                        .slice()
                        .sort((a, b) => (b.UpdatedAt.getTime() > a.UpdatedAt.getTime() ? -1 : b.UpdatedAt.getTime() === a.UpdatedAt.getTime() ? 0 : 1));
                    return this.mapper({
                        commissions,
                        damageFlows,
                        StatusBackoffice,
                        customers,
                        commissionTyp,
                        users,
                        roles,
                        u2cDict,
                        u2cCIdsMap,
                        userDict,
                    });
                }),
                tap(() => loading$.next(false)),
                finalize(() => loading$.next(false)),
                switchMap((dataSource) =>
                    this.searchForm.valueChanges.pipe(
                        debounceTime(SearchQueriesDebounceTime),
                        startWith(''),
                        tap(() => (dataSource.filter = this.searchForm.value.trim().toLowerCase())),
                        map(() => dataSource),
                    ),
                ),
            );
        }).pipe(
            shareReplay({ refCount: true, bufferSize: 1 }),
        );

        return { dataSource$, loading$: loading$.asObservable() };
    }

    private availableColumns: Array<CommissionListColumn | string> = [
        'Auftraggeber',
        'InterneNr',
        'Description',
        'AuftragsNr',
        'Auftragstyp',
        'Address',
        'StartDate',
        'EndDate',
        'Datum',
        'Ort',
        'AbgabeterminAG',
        'Author',
        'StatusBackoffice',
        'Projektleiter',
        'Vorarbeiter',
        'Sachbearbeiter',
        'SchadenNr',
        'VersicherungsNr',
        'lastComment',
        'offerSum',
        'freeTextField1',
        'OfferSubmissionDate',
        'NegotiationAt',
        'CompleteBusinessVolume',
    ];
    public displayedColumns: string[];
    selectedColumns$: Observable<Array<string>> ;
    public disabledColumns$: Observable<number>;
    public TableColumnsSorted$: Observable<TableColumnConfig<TableData, CommissionListColumn | string>[]>;
    private baseColumns$: Observable<TableColumnConfig<TableData, CommissionListColumn>[]> = combineLatest([
        this.cls.getSingle$('CustomerSupplier'),
        this.cls.getLabels$('Commission'),
        this.cls.getSingle$('CommissionInternalNumberShort'),
        this.cls.getSingle$('CommissionDescription'),
        this.cls.labels$,
    ]).pipe(
        take(1),
        map(([customerLabel, commissionLabels, interneNr, commissionDescription, customLabels]) => [
            { header: interneNr, name: 'InterneNr' },
            { header: commissionLabels.wordBinding + 'Nr', name: 'AuftragsNr' },
            { header: 'Status', name: 'StatusBackoffice' },
            { header: 'Start', name: 'StartDate' },
            { header: 'Ende', name: 'EndDate' },
            { header: 'Frist', name: 'Datum' },
            { header: 'Ort', name: 'Ort' },
            { header: commissionDescription, name: 'Description' },
            { header: 'SchadenNr', name: 'SchadenNr', width: '7rem' },
            { header: 'VersicherungsNr', name: 'VersicherungsNr', width: '' },
            { header: customerLabel, name: 'Auftraggeber', width: '12rem' },
            { header: 'AG', name: 'AbgabeterminAG', width: '5rem' },
            { header: 'Adresse', name: 'Address', width: '14rem' },
            { header: commissionLabels.wordBinding + 'typ', name: 'Auftragstyp', width: '14rem' },
            { header: 'Autor', name: 'Author', width: '12rem' },
            { header: 'Kommentar', name: 'lastComment', width: '14rem' },
            { header: 'Angebotssumme', name: 'offerSum', width: '10rem' },
            { header: customLabels.CommissionFreeTextField1.Nominativ.plural.value, name: 'freeTextField1', width: '10rem' },
            { header: CommissionEntity.EntityPropertyNames.get('CostCenter'), name: 'CostCenter', width: '10rem' },
            { header: 'Angebotsabgabe', name: 'OfferSubmissionDate', width: '10rem' },
            { header: 'Verhandlung am', name: 'NegotiationAt', width: '10rem' },
            { header: customLabels.CommissionCompleteBusinessVolume.Nominativ.singular.value, name: 'CompleteBusinessVolume', width: '10rem' },
        ]),
    );
    public Columns: TableColumnConfig<TableData, CommissionListColumn | string>[] = [];
    private buildColumns(): void {
        combineLatest([
            this.commissionEntityRoles$,
            this.baseColumns$,
        ]).pipe(take(1)).subscribe(([roles, baseColumns]) => {
            const columnsBehindRoles: CommissionListColumn[] = ['Auftraggeber', 'Datum', 'AbgabeterminAG', 'StatusBackoffice', 'StartDate', 'EndDate', 'Address', 'Description', 'Auftragstyp', 'Author'];

            let indexOfRoles = baseColumns.length;
            baseColumns.forEach((col, i) => {
                if (columnsBehindRoles.includes(col.name)) {
                    indexOfRoles = i;
                }
            });

            const roleColumns = roles.map(role => ({
                header: role.Name,
                name: roleKeyPrefix + role.Id,
                width: '12rem',
                cell: (rowData: TableData) => rowData.roleCols[roleKeyPrefix + role.Id],
            }));

            this.Columns = [
                ...baseColumns.slice(0, indexOfRoles - 1),
                ...roleColumns,
                ...baseColumns.slice(indexOfRoles - 1),
            ];
        });
    }

    public entitiesFetched$ = combineLatest([
        this.store.select(getCommissionsFetched),
        this.store.select(getDamageFlowsFetched),
        this.store.select(getStatusFromBackofficeFetched),
    ]).pipe(map(fetched => fetched.every(f => f)))

    public Tabs$: Observable<{
        label: string;
        dataSource$: Observable<MatLegacyTableDataSource<TableData>>;
        displayedColumns: Array<keyof TableData | 'settingsButton' | string>;
        loading$: Observable<boolean>;
    }[]>
    // = combineLatest([
    //     this.selectedColumns$,
    //     this.store.select(getPartner).pipe(
    //         map((partner) => partner.PartnerSpecificationTypeId === PartnerSpecificationType.Appraiser),
    //         distinctUntilChanged(),
    //     ),
    //     this.store.select(getSetting),
    //     getFetched$(this.store, getStatusFromBackofficeFetched, getStatusFromBackofficeDictionary),
    // ]).pipe(
    //     map(([_, isAppraiser, settings, statusBo]) => {
    //         const displayedColumns: string[] = this.displayedColumns;
    //         const stateBackoffice: StatusFromBackofficeEntity[] = [];
    //
    //         if (settings?.CommissionDashboardComponentCommissionTypeIds?.length) {
    //             settings.CommissionDashboardComponentCommissionTypeIds.forEach((stateId) => {
    //                 stateBackoffice.push(statusBo[stateId]);
    //             });
    //         } else {
    //             const fallback = ['bearbeitung', 'offen', 'neu'];
    //             fallback.forEach((name) => {
    //                 stateBackoffice.push(
    //                     Object.values(statusBo).find((status) =>
    //                         status.Name.toLocaleLowerCase().includes(name),
    //                     ),
    //                 );
    //             });
    //             if (fallback.length !== stateBackoffice.filter(isNotNullOrUndefined).length) {
    //                 stateBackoffice.length = 0;
    //                 Object.values(statusBo)
    //                     .filter((status) => !status.IsCompleted)
    //                     .forEach((status) => stateBackoffice.push(status));
    //             }
    //         }
    //
    //         return stateBackoffice
    //             .filter(isNotNullOrUndefined)
    //             .map((s) => ({
    //                 label: s.Name,
    //                 dataSource$: this.getDataSourceByBackofficeStatus(s.Id),
    //                 displayedColumns,
    //             }));
    //     }),
    // );

    filteredColumnsCustom: TableColumnConfig<TableData, CommissionListColumn | string>[] = [];
    filteredColumnsDate: TableColumnConfig<TableData, CommissionListColumn | string>[] = [];
    protected commentsFetched$ = this.store.select(getCommentFetched);
    protected ledgerImportsFetched$ = this.store.select(getLedgerImportsFetched);

    private commentsAfterFetched$ = getFetched$(this.store, getCommentFetched, getCommentFetched, this.commentResolver).pipe(
        distinctUntilChanged(),
        shareReplay({bufferSize: 1, refCount: true}),
    );
    private ledgerImports$ = getFetched$(this.store, getLedgerImportsFetched, getLedgerImports, this.liResolver).pipe(
        distinctUntilChanged(),
        shareReplay({bufferSize: 1, refCount: true}),
    );
    protected commissionsLabel$: Observable<string> = this.cls.getMultiple$('Commission');
    constructor(
        userToCommissionResolver: UserToCommissionResolver,
        @Inject(LOCALE_ID) private local: string,
        private dialog: MatDialog,
        private commentResolver: CommentResolver,
        private liResolver: LedgerImportResolver,
        private store: Store<State>,
        damageFlows: DamageFlowResolver,
        statusFromBackoffice: StatusFromBackofficeResolver,
        protected cls: CustomLabelService,
        private customerDataService: CustomerDataService,
        private datePipe: DatePipe,
    ) {
        userToCommissionResolver.resolve()
        this.buildColumns();
        damageFlows.resolve();
        statusFromBackoffice.resolve();
        // this.subscriptions.push(this.BearbeitungDataSource$.subscribe(), this.FaelligDataSource$.subscribe(), this.OpenDataSource$.subscribe(), this.NewDataSource$.subscribe());
        this.selectedColumns$ = combineLatest([
            getFetched$(this.store, getSettingFetched, getSetting),
            getFetched$(this.store, getPartnerFetched, getPartner),
        ]).pipe(
            map(([ settings, partner]) => {
                const fallback: CommissionListColumn[] = [
                    'InterneNr',
                    'Description',
                    'Address',
                ]
                const selectableColumns = this.Columns.map(c => c.name);
                const displayedColumns = settings.CommissionDashbordListComponentDisplayedColumns
                    || partner?.AdditionalData?.CommissionDashbordListComponentDisplayedColumns
                    || fallback;

                return displayedColumns.filter(
                    (c) => selectableColumns.includes(c as CommissionListColumn) || c.startsWith(roleKeyPrefix)
                ) as CommissionListColumn[];
            }),
            distinctUntilChanged((a, b) => compareArrays(a, b)),
            shareReplay({ bufferSize: 1, refCount: true }),
        );

        this.selectedColumns$.pipe(takeUntil(this.destroy$)).subscribe((columns) => {

            this.availableColumns = columns;

            this.displayedColumns = this.Columns.filter(col => columns.includes(col.name as keyof TableData)).map(col => col.name);
            this.displayedColumns = [...columns, 'settingsButton'];


            this.filteredColumnsCustom = this.Columns.filter(this.FilterCustomColumns);
            this.filteredColumnsDate = this.Columns.filter(this.FilterDateColumns);
        });
        this.Tabs$ = combineLatest([
            this.selectedColumns$,
            this.store.select(getPartner).pipe(
                map((partner) => partner.PartnerSpecificationTypeId === PartnerSpecificationType.Appraiser),
                distinctUntilChanged(),
            ),
            this.store.select(getSetting),
            getFetched$(this.store, getStatusFromBackofficeFetched, getStatusFromBackofficeDictionary),
        ]).pipe(
            map(([_, isAppraiser, settings, statusBo]) => {
                const displayedColumns: string[] = this.displayedColumns;
                const stateBackoffice: StatusFromBackofficeEntity[] = [];

                if (settings?.CommissionDashboardComponentCommissionTypeIds?.length) {
                    settings.CommissionDashboardComponentCommissionTypeIds.forEach((stateId) => {
                        stateBackoffice.push(statusBo[stateId]);
                    });
                } else {
                    const fallback = ['bearbeitung', 'offen', 'neu'];
                    fallback.forEach((name) => {
                        stateBackoffice.push(
                            Object.values(statusBo).find((status) =>
                                status.Name.toLocaleLowerCase().includes(name),
                            ),
                        );
                    });
                    if (fallback.length !== stateBackoffice.filter(isNotNullOrUndefined).length) {
                        stateBackoffice.length = 0;
                        Object.values(statusBo)
                            .filter((status) => !status.IsCompleted)
                            .forEach((status) => stateBackoffice.push(status));
                    }
                }

                return stateBackoffice
                    .filter(isNotNullOrUndefined)
                    .map((s) => {
                        const { dataSource$, loading$ } = this.getDataSourceByBackofficeStatus(s.Id);
                        return {
                            label: s.Name,
                            dataSource$,
                            loading$,
                            displayedColumns,
                        };
                    });
            }),
        );


        this.TableColumnsSorted$ = this.selectedColumns$.pipe(
            map((selected) => {

                return this.Columns.sort((a, b) => selected.indexOf(a.name) - selected.indexOf(b.name));
            }),
        );

        this.disabledColumns$ = combineLatest([this.TableColumnsSorted$, this.selectedColumns$]).pipe(map(([all, selected]) => all.length - selected.length || undefined));
        this.filteredColumnsCustom = this.Columns.filter(this.FilterCustomColumns);
        this.filteredColumnsDate = this.Columns.filter(this.FilterDateColumns);
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach((s) => s.unsubscribe());

        this.destroy$.next();
        this.destroy$.complete();
    }

    ngAfterViewInit(): void {
        this.afterViewInit$.next();
    }

    public FilterCustomColumns(c: TableColumnConfig<TableData, CommissionListColumn | string > | { name: 'settingsButton' }) {
        return !(c.name === 'Datum' || c.name === 'StartDate' || c.name === 'EndDate' || c.name === 'settingsButton');
    }
    public FilterDateColumns(c: TableColumnConfig<TableData, CommissionListColumn | string>) {
        return c.name === 'Datum' || c.name === 'StartDate' || c.name === 'EndDate';
    }
    onSearchBtnClick() {
        this.searchVisible = !this.searchVisible;
        this.searchForm.setValue('');
        if (this.searchVisible) {
            setTimeout(() => this.searchInput?.nativeElement?.focus(), 1);
        }
    }


    selectedColumnsChange(selectedColumns: Array<keyof TableData>) {
        this.store.dispatch(
            new ChangeSettings({
                CommissionDashbordListComponentDisplayedColumns: selectedColumns,
            }),
        );
        this.availableColumns = selectedColumns;

        this.displayedColumns = this.Columns.filter(col => selectedColumns.includes(col.name as keyof TableData)).map(col => col.name);
        this.displayedColumns = [...selectedColumns, 'settingsButton'];
    }


    protected readonly CommentIcon = CommentIcon;

    onCommentClick(commissionId: number) {
        this.dialog.open<CommentListDialogComponent, CommentListDialogComponentDialogData>(CommentListDialogComponent, {
            ...CommentListDialogComponent.DefaultConfig,
            data: {
                entityType: CommentEntityTypeEnum.Commission,
                entityId: commissionId,
            }
        })
    }

    OpenUserSelect(commissionId: number) {
        this.dialog.open<SelectUserCommissionDialogComponent, SelectUserCommissionDialogComponentDialogData>(SelectUserCommissionDialogComponent, {
            ...SelectUserCommissionDialogComponent.DefaultConfig,
            data: {
                commissionId: commissionId,
                hideStartDate: true,
            },
        });
    }

    public SortTableData(sortEvent: Sort, dataSource$: Observable<MatLegacyTableDataSource<TableData>>, matSort: MatSort) {
        dataSource$.pipe(
            take(1)
        ).subscribe((dataSource) => {
            dataSource.sort = matSort;
            dataSource.sort.active = sortEvent.active
            dataSource.sort.direction = sortEvent.direction
        })
    }

    drop(event: CdkDragDrop<string[]>) {
        moveItemInArray(this.displayedColumns, event.previousIndex, event.currentIndex);

        this.store.dispatch(
            new ChangeSettings({
                CommissionDashbordListComponentDisplayedColumns: this.displayedColumns.filter(col => col !== "settingsButton"),
            }),
        );
    }


    mapper = (input: {
        commissions: CommissionEntity[];
        damageFlows: DamageFlowEntity[];
        StatusBackoffice: StatusFromBackofficeEntity;
        customers: Dictionary<CustomerEntity>;
        commissionTyp: CommissionTypeEntity[];
        users: UserEntity[];
        roles: EntityRoleEntity[];
        u2cDict:  Dictionary<UserToCommissionEntity>;
        u2cCIdsMap:  Map<number, number[]>;
        userDict: Dictionary<UserEntity>
    }) => {
        const dataSource = new MatLegacyTableDataSource(
            input.commissions.map<TableData>((commission) => {
                const routerLink = [CommissionMeta.Path, commission.Id];
                const damageFlow = input.damageFlows.find((df) => df.CommissionId === commission.Id);
                const now = new Date();
                now.setDate(now.getDate() + 2);
                let tooltip = (commission.CustomerId && input.customers[commission.CustomerId]?.DisplayName) || '';

                const commissonType = input.commissionTyp.find((c) => c.Id === commission?.CommissionTypeId);
                if (tooltip) {
                    tooltip += `\n`;
                }
                tooltip = commission.LastDeadline
                    ? tooltip + 'Frist: ' + commission.LastDeadline.getDate() + '.' + (commission.LastDeadline.getMonth() + 1) + '.' + commission.LastDeadline.getFullYear()
                    : tooltip;
                const u2csByCommission = (input.u2cCIdsMap.get(commission.Id) || []).filter(isNotNullOrUndefined).map((id) => input.u2cDict[id]);
                const roleCols: { [key: string]: string } = {};

                const commissionColorValue = getCommissionColorValue(commission, commissonType);

                input.roles.forEach((r) => {
                    roleCols[roleKeyPrefix + r.Id] = getUserNamesByRoleId(u2csByCommission, r.Id, input.userDict);
                });

                return {
                    id: commission.Id,
                    Auftrag: commission,
                    AuftragsNr: commission.Auftragsnummer || '-',
                    InterneNr: commission.InterneNummer || '-',
                    Ort: damageFlow?.City || '-',
                    Description: commission.Description || '-',
                    Datum: commission.LastDeadline,
                    DatumAsMillis: commission.LastDeadline ? commission.LastDeadline.getTime() : null,
                    RouterLink: routerLink,
                    backgroundColor: commission.GetBackgroundColor(input.StatusBackoffice.IsCompleted, input.StatusBackoffice.Color),
                    tooltip,
                    StatusBackoffice: input.StatusBackoffice?.Name,
                    StartDate: commission.StartDate || commission.PlannedStartDate,
                    StartDateAsMillis: commission.StartDate ? commission.StartDate.getTime() : commission.PlannedStartDate ? commission.PlannedStartDate.getTime() : null,
                    EndDate: commission.EndDate || commission.PlannedEndDate,
                    EndDateAsMillis: commission.EndDate ? commission.EndDate.getTime() : commission.PlannedEndDate ? commission.PlannedEndDate.getTime() : null,
                    SchadenNr: commission.Schadennummer || '-',
                    VersicherungsNr: commission.Versicherungsnummer || '-',
                    Auftraggeber: tooltip || '-',
                    AbgabeterminAG: commission.AbgabeterminAG?.toLocaleDateString('de-DE'),
                    Address: getAddressString(commission),
                    Auftragstyp: commissonType?.Name || '-',
                    Author: (commission.UserId && input.users[commission.UserId]?.DisplayName) || '',
                    freeTextField1: commission.FreeTextField1,
                    lastComment$: this.commentsAfterFetched$.pipe(
                        switchMap((): Observable<CommentEntity[]> =>
                            this.store.select(getCommentByEntityTypeEntityId({
                                entityId: commission.Id,
                                entityType: CommentEntityTypeEnum.Commission
                            }))
                        ),
                        map((comments: CommentEntity[] = []) =>
                            comments.sort((a, b) => b.CreatedAt.getTime() - a.CreatedAt.getTime())[0]?.htmlText || ''
                        )
                    ),
                    offerSum$: this.ledgerImports$.pipe(map((ledgerImports) => {
                        const li = ledgerImports.filter(li => li.CommissionId === commission.Id && (li.DocumentType === LedgerImportDocumentTypes.OfferConfirmation || li.DocumentType === LedgerImportDocumentTypes.Offer)).sort((a, b) => {
                            if (a.DocumentType === b.DocumentType) {if ((a.Status === LedgerImportStatusEnum.AngebotAkzeptiert) === (b.Status === LedgerImportStatusEnum.AngebotAkzeptiert)) {
                                return b.CreatedAt.getTime() - a.CreatedAt.getTime();
                            }
                                return a.Status === LedgerImportStatusEnum.AngebotAkzeptiert ? -1 : 1;
                            }
                            return a.DocumentType === LedgerImportDocumentTypes.OfferConfirmation ? -1 : 1;
                        })[0];
                        if (li) {
                            return formatCurrency((li.ConsolidatedNettoAmount || 0) / 100, this.local, getCurrencySymbol(li.ConsolidatedCurrencyCode, 'narrow'), li.ConsolidatedCurrencyCode)
                        }
                        return null;
                    })),
                    roleCols,
                    colorBarValue: commissionColorValue,
                    CostCenter: commission.CostCenter,
                    OfferSubmissionDate: this.datePipe.transform(commission.OfferSubmissionDate, 'dd.MM.yyyy HH:mm'),
                    OfferSubmissionDateAsMillis: commission.OfferSubmissionDate ? commission.OfferSubmissionDate.getTime() : null,
                    NegotiationAt: this.datePipe.transform(commission.NegotiationAt, 'dd.MM.yyyy HH:mm'),
                    NegotiationAtAsMillis: commission.NegotiationAt ? commission.NegotiationAt.getTime() : null,
                    CompleteBusinessVolume: commission?.CompleteBusinessVolume ? formatCurrency((commission.CompleteBusinessVolume || 0) / 100, this.local, getCurrencySymbol("EUR", 'narrow'), "EUR") : null,
                };
            }),
        );

        dataSource.filterPredicate = (data, searchTerm) =>
            [data.Description, data.Auftraggeber, data.InterneNr, data.AuftragsNr, data.StatusBackoffice, data.StartDate, data.EndDate, data.Datum, data.Ort]
                .filter((v) => !!v)
                .map((value) => `${value}`.trim().toLowerCase())
                .some((value) => value.includes(searchTerm));

        dataSource.sortingDataAccessor = (
            object: TableData,
            key: keyof  TableData,
        ): any => {
            switch (key) {
                case 'Datum':
                    return object.DatumAsMillis;
                case 'StartDate':
                    return object.StartDateAsMillis;
                case 'EndDate':
                    return object.EndDateAsMillis;
                case 'OfferSubmissionDate':
                    return object.OfferSubmissionDateAsMillis;
                case 'NegotiationAt':
                    return object.NegotiationAtAsMillis;
                case 'CompleteBusinessVolume':
                    return object.Auftrag.CompleteBusinessVolume ?? 0;
                default:
                    return object[key];
            }
        }

        dataSource.sortData = (_, sort) => {
          return sortMatTableData(dataSource, sort);
        };

        return dataSource;
    };
}
